import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { AsyncPipe } from '@angular/common';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ImageViewerComponent } from "./shared/components/image-viewer/image-viewer.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, LoaderComponent, ImageViewerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {

  title = 'traze-webshop';

}
